import { apiUri } from '../appConfig';

const restaurantList = () => (
	fetch(`${apiUri}/restaurant`)
		.then((res) => res.json())
		.catch((err) => console.error(err))
);

export default restaurantList;



// WEBPACK FOOTER //
// ./src/js/request/restaurantList.js